import { Resources } from 'constants/resources';

import { useGetOne } from 'react-admin';
import { Gateway, GatewayPilotModeSchedule } from 'types/embedded/gateway';

type UseGatewayPilotModeScheduleReturnValues = {
  gatewayPilotModeSchedule?: GatewayPilotModeSchedule | null;
  isScheduleLoading: boolean;
};

export function useGatewayPilotModeSchedule(
  record?: Gateway,
): UseGatewayPilotModeScheduleReturnValues {
  const recordSchedule = record?.gatewayPilotModeSchedule;
  const scheduleIri = typeof recordSchedule === 'string' ? recordSchedule : undefined;

  const { data: fetchedSchedule } = useGetOne<Required<GatewayPilotModeSchedule>>(
    Resources.GatewayPilotModeSchedules,
    { id: scheduleIri },
    { enabled: !!scheduleIri },
  );

  return {
    gatewayPilotModeSchedule: typeof recordSchedule === 'string' ? fetchedSchedule : recordSchedule,
    isScheduleLoading: !!scheduleIri && !fetchedSchedule,
  };
}
